import { useCallback } from "react";

import { sectionSelectors } from "store/selectors";
import { useListSelector } from "store/store-hooks";
import { filterMap } from "utils/collections";

/** Returns a stable factory that maps a term ID to the Set of course IDs with sections in that term. */
export function useCourseIdsInTerm(): (termId: string) => Set<string> {
  const sections = useListSelector(sectionSelectors.selectAll, ["term_id", "course_id"]);
  return useCallback(
    (termId: string) =>
      new Set(
        filterMap(
          sections,
          (section) => section.term_id === termId,
          (section) => section.course_id,
        ),
      ),
    [sections],
  );
}
